import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import swal from "sweetalert2";
import { Card, CardBody, Button } from "shards-react";
import { EntypoUser, EntypoMail, EntypoPhone } from "react-entypo-icons";
import Navbar from "../../components/navbar/Navbar";
import { strings } from "../../localization";
import Footer from "../../components/Footer/Footer";
import { withRouter } from "react-router-dom";
import { ORG_ID, TABLE_ID } from "../../config";
window.Swal = swal;

const ContactUs = ({match, location}) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    description: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", form);
    // Optionally add form validation or submission API here
    swal
      .fire(
        strings.contact_us_success_title_msg,
        strings.contact_us_success_msg,
        "success"
      )
      .then(() => {
        setForm({
          name: "",
          email: "",
          mobile: "",
          description: "",
        });
      });
  };

  return (
    <div className="vh-100 overflow-auto">
      <Navbar />
      <Container className="my-4">
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6}>
            <Card className="p-3 shadow-sm rounded">
              <CardBody>
                <div className="text-center mb-4">
                  <h4>{strings.contact_us}</h4>
                </div>
                <Form onSubmit={handleSubmit}>
                  {/* Name Field */}
                  <Form.Group controlId="name" className="mb-3">
                    <Form.Label>
                      <EntypoUser size={18} className="me-2" />
                      {strings.name}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder={strings.name}
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  {/* Email Field */}
                  <Form.Group controlId="email" className="mb-3">
                    <Form.Label>
                      <EntypoMail size={18} className="me-2" />
                      {strings.email}
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder={strings.email}
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  {/* Mobile Number Field */}
                  <Form.Group controlId="mobile" className="mb-3">
                    <Form.Label>
                      <EntypoPhone size={18} className="me-2" />
                      {strings.mobile_number}
                    </Form.Label>
                    <Form.Control
                      type="tel"
                      name="mobile"
                      placeholder={strings.mobile_number}
                      pattern="[0-9]{10}"
                      value={form.mobile}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  {/* Description Field */}
                  <Form.Group controlId="description" className="mb-4">
                    <Form.Label>{strings.item_desc}</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="description"
                      placeholder={`${strings.write_your_msg}...`}
                      rows={4}
                      value={form.description}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  {/* Submit Button */}
                  <Button type="submit" theme="primary" block className="w-100">
                    {strings.send_message}
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default withRouter(ContactUs);
